import { FC } from 'react';
import { Box, Drawer, DrawerProps, Stack, Typography, IconButton } from '@mui/material';
import { ClearOutlined as ClearOutlinedIcon } from '@mui/icons-material';

import Block from '../../../../../components/Block';
import Column from '../../../../../components/Column';
import Row from '../../../../../components/Row';

import { AdCreative } from '../../../../../types/AmazonAds';
import CampaignAdGroupCreativeCard from '../Card/CampaignCreativeCard';

type CampaignAdCreativeDrawerActionCallback = (dspAdCreative?: AdCreative) => void;

interface CampaignAdCreativeDrawerProps extends DrawerProps {
    dspAdCreative: AdCreative;
    onCancel?: CampaignAdCreativeDrawerActionCallback;
    onSave?: CampaignAdCreativeDrawerActionCallback;
}

const CampaignAdCreativeDrawer: FC<CampaignAdCreativeDrawerProps> = ({ dspAdCreative, onCancel, onSave, ...props }) => {
    return (
        <Drawer
            anchor="right"
            {...props}
            sx={{
                width: 5 / 12,
                flexShrink: 0,
                zIndex: (theme) => theme.zIndex.drawer + 1,

                '& .MuiDrawer-paper': {
                    width: 5 / 12,
                    boxSizing: 'border-box',
                },
            }}
        >
            <Column
                justifyContent="space-between"
                sx={{
                    minHeight: '480px',
                    height: '100%',
                }}
            >
                <Box>
                    <Box
                        component="header"
                        sx={{
                            borderBottom: 1,
                            borderColor: 'divider',
                            paddingX: 3,
                            paddingY: 2,
                        }}
                    >
                        <Row justifyContent="space-between" alignItems="center" spacing={2}>
                            <Stack spacing={1}>
                                <Typography variant="h6">{dspAdCreative?.name}</Typography>
                            </Stack>

                            <IconButton onClick={() => onCancel?.(dspAdCreative)} edge="end">
                                <ClearOutlinedIcon fontSize="medium" color="action" />
                            </IconButton>
                        </Row>
                    </Box>

                    <Block px={4} py={3}>
                        <CampaignAdGroupCreativeCard dspAdCreative={dspAdCreative} />
                    </Block>
                </Box>
            </Column>
        </Drawer>
    );
};

export default CampaignAdCreativeDrawer;
